/* eslint-disable */
import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import Button from "../../components/ui/Button";
import { IAmount } from "./Amount";
import {
  DropdownIcon,
  Editable,
  LockIcon,
  NotEditable,
  TransferIcon,
  UnlockIcon,
} from "../../assets/Icons";
import { UserTransactionDetails } from "../../store/store";
import { useRecoilValue } from "recoil";
import { DebounceInput } from "react-debounce-input";
import ErrorField from "../../components/ui/ErrorField";
import { additionalDocumentsList, formatNumber, getSendMoneyErrorMessage } from "../../utils";
import { useRecoilState } from "recoil";
import { declarationDefault, openLoanModal, selectVendor, transactionDetails, vendorCodes } from "../../store";
import { Dialog, TextField } from "@material-ui/core";
import Dropdown from "../../components/ui/Dropdown";
import { getVendorCode } from "../../services/purposeCode";
import { Autocomplete } from "@material-ui/lab";
import DownloadIcon from "../../assets/Icons/DownloadIcon";
import { Axios } from "../../services/axios";
import download from "downloadjs";
import { ToastContainer, toast } from "react-toastify";
import VendorDropdown from "./VendorDropDown";

export const PaymentOverview: FunctionComponent<IAmount.PaymentOverviewProps> = ({
  sendingAmount,
  setSendingAmount,
  recievingAmount,
  setReceivingAmount,
  rate,
  setRate,
  destCurrency,
  setIsModalOpen,
  base_currency,
  purposeCode,
  proceedClick,
  purposeValue,
  errorMessage,
  // sendTransferSummary,
  // rateTransferSummary,
  // receiveTransferSummary,
  setIsPurposeModalOpen,
  isErrorPresent,
  setReceiveLocked,
  receiveLocked,
  setErrorMessage,
  cardRates,
  firstTimeLoanPopup,
  setFirstTimeLoanPopup,
  loading,
  tcs,
  setOnChangeHandleType
}) => {
  const transactionData: UserTransactionDetails = useRecoilValue(transactionDetails);
  const [editable, setEditable] = useState<boolean>(false);
  const [recieveDisabled, setReceiveDisabled] = useState<boolean>(false);
  const [openModal, setOpenModal] = useRecoilState(openLoanModal);
  const [vendorCodeList, setVendorCodeList] = useRecoilState(vendorCodes);
  const [vendorCode, setVendorCode] = useRecoilState(selectVendor);
  const [data, setData] = useState<any>([]);
  const [inputValue, setInputValue] = useState("");
  const [formattedSendAmount, setFormattedSendAmount] = useState("");
  const [formattedReceiveAmount, setFormattedReceiveAmount] = useState("");
  const [vendorData, setVendorData] = useState("")

  const handleLockClick = () => {
    setReceiveLocked(!receiveLocked);
  };
  const handleDataFromChild = (data: string) => {
    setVendorData(data);
  };

  useEffect(() => {
    if (receiveLocked === true) {
      setReceiveDisabled(true);
    } else if (receiveLocked === false) {
      setReceiveDisabled(false);
    }
    handleVendorCodes();
  }, [receiveLocked]);

  const validateRate = (e: any) => {
    if (Number(e.target.value) < 0) {
      setErrorMessage("Min value should be ZERO");
    } else {
      setErrorMessage("");
      // rateTransferSummary(e.target.value);
    }
    setRate(e.target.value);
  };

  const handleVendorCodes = () => {
    getVendorCode()
      .then((res: any) => {
        setData(res?.data);
        // setDefaultVendorCode(res?.data.filter((data: any)=>data?.userId === userId));
        // console.log("Vendor Codes", res?.data);
      })
      .catch((error) => {
        console.error("ERROR", error);
      });
  };

  const handleDownloadQuoteClick = async () => {
    let vendor_code;
    data
      .filter(
        (item: { displayName: string | null; userId: string; vendorCode: string }) =>
          item.vendorCode === vendorCode?.vendorCode,
      )
      .map((item: { displayName: string | null; userId: string; vendorCode: string }) => {
        vendor_code = item.userId;
      });


    const purpose = additionalDocumentsList.find((item) => item.name === purposeValue)?.code;
    const userId = localStorage.getItem("userKey") || "{}";
    const Money_you_send = sendingAmount.toString();
    const Money_they_receive = recievingAmount.toString();
    const Exchange_rate = rate.toString();

    const totalTaxes_charges =
      transactionData.total_tax +
      transactionData.nostro_charges +
      transactionData.nostro_charges_new +
      transactionData.hop_fees +
      transactionData.tcs;
    const totalFees = totalTaxes_charges.toString();
    const youPay = parseFloat(Money_you_send) + parseFloat(totalFees);

    if (!sendingAmount || !recievingAmount || !rate || !vendor_code || !purpose) {
      toast.error("TO DOWNLOAD QUOTE, FILL VENDORCODE AND PURPOSECODE");
      return;
    }

    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    try {
      const response = await Axios.get(`remit/user/${userId}/quote`, {
        params: {
          transVendorKey: vendorCode?.userId,
          destinationCurrency: destCurrency,
          conversionRate: Exchange_rate,
          recipientReceive: Money_they_receive,
          taxes: transactionData.total_tax,
          totalPay: youPay,
          purposeCode: purpose,
          userSend: sendingAmount,
          tcs: transactionData.tcs,
          bankFee: transactionData.nostro_charges,
          nostro: transactionData.nostro_charges_new,
          vendorFee: transactionData.hop_fees,
        },
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
        responseType: "blob",
      });
      if (response?.status === 200) {
        const content = response.headers["content-type"];

        download(response.data, "Quote.pdf", content);
      } else {
        if (
          response.data &&
          response.data.error &&
          response.data.error.code === 2000 &&
          response.data.error.type === "User Send cannot be less than 5000"
        ) {
          console.log("User Send cannot be less than 5000");
        }
        toast.error(`${response?.data?.error?.type}`);
      }
    } catch (error: any) {
      // Check if the error response contains the expected error structure
      if (error.data && error.data.error) {
        toast.error(`${error.data.error.type}`);
      } else {
        // General error handling
        toast.error("An unexpected error occurred.");
      }
    }
  };

  const showCardRate = cardRates?.find((cardRate) => cardRate?.currency === destCurrency);
  const cardRateToShow =
    purposeValue === "Family Maintenance" || purposeValue === "Personal Gift or Donation"
      ? showCardRate?.cardRateAd1
      : showCardRate?.cardRate;

  useEffect(() => {
    const formatted = formatNumber(sendingAmount);
    setFormattedSendAmount(formatted ?? "");
  }, [sendingAmount]);

  useEffect(() => {
    const formatted: any = formatNumber(recievingAmount);
    if (!isNaN(Number(formatted?.replace(/,/g, "")))) {
      setFormattedReceiveAmount(formatted);
    }
  }, [recievingAmount]);


  return (
    <div id="paymentOverview" className="w-[600px] space-y-10">
      <div className="flex flex-col ml-[4%]">
        <span className="text-[28px] font-bold">Amount</span>
        <span className="text-[20px]">Enter the amount of the transaction.</span>
      </div>
      <div className="w-full p-5 m-6 space-y-5 border border-gray-400 rounded">
        <div id="youSend" className="flex flex-col justify-center">
          <span className="font-semibold text-[19px]">You Send</span>
          <div className="flex items-center mr-5 my-3">
            <DebounceInput
              minLength={2}
              className="w-full rounded-md p-[3.4%] bg-blue-100 text-lg outline-none"
              name="sendingAmount"
              type="text"
              maxLength={15}
              value={formattedSendAmount}
              debounceTimeout={0}
              onChange={(e: any) => {
                const newAmount = e.target.value.replace(/,/g, "");
                setSendingAmount(newAmount);
                setOpenModal(purposeCode === "S0305"); //&& e.target.value >= 700000
                // if (receiveLocked) {
                //   receiveTransferSummary(recievingAmount, false);
                // } else {
                //   sendTransferSummary(newAmount, destCurrency, false);
                // }
                setOnChangeHandleType("send");
              }}
              disabled={receiveLocked}
            />
            <div className="flex py-[17px] w-[155px] space-x-4 border rounded-md cursor-pointer">
              <img
                src={`/images/png/INR.png`}
                alt="country-image"
                className="rounded-[200px] w-7 h-7 ml-5"
              />
              <span className="bg-white text-[19px]">{base_currency}</span>
            </div>
          </div>
          {/* <ErrorField
            errorMessage={getSendMoneyErrorMessage(destCurrency, sendingAmount)}
            errorClassname="relative"
          /> */}
            <span className="font-semibold text-red-500 text-[13px] animate-fade">
              {errorMessage && errorMessage}
            </span>
        </div>
        <div id="theyRecieve" className="flex flex-col justify-center">
          <span className="text-[19px] font-semibold">They Receive</span>
          <div className="flex mr-5 my-3">
            <DebounceInput
              minLength={2}
              className="w-full rounded-l-md p-[3.4%] bg-blue-100 text-lg outline-none"
              name="recievingAmount"
              type="text"
              value={loading ? "" :formattedReceiveAmount}
              debounceTimeout={0}
              disabled={recieveDisabled}
              onChange={(e: any) => {
                const newAmount = e.target.value.replace(/,/g, "");
                setReceivingAmount(newAmount);
                setOpenModal(purposeCode === "S0305");
                // receiveTransferSummary(newAmount, false);
                setOnChangeHandleType("receive");

              }}
            />
            <div
              id="lockIcon"
              className="flex items-center justify-center pr-2 bg-blue-100 cursor-pointer"
              onClick={handleLockClick}
            >
              {receiveLocked ? <LockIcon /> : <UnlockIcon />}
            </div>
            <div
              onClick={() => setIsModalOpen("recieve")}
              className="flex py-[17px] w-[155px] space-x-3 border rounded-md cursor-pointer"
            >
              <img
                src={`/images/png/${destCurrency}.png`}
                alt="receiving-country-image"
                className="rounded-[200px] w-7 h-7 ml-3"
              />
              <span className="bg-white text-[19px] space-x-2 flex items-center">
                <span className="-ml-2">{destCurrency}</span>
                <DropdownIcon />
              </span>
            </div>
          </div>
        </div>
        {/* {receiveLocked &&
            <span className="text-red-200 ml-[10px]">
              
            </span>
         } */}
        <div
          id="purposeCode"
          className="flex flex-col items-start justify-center space-y-3 animate-ping"
        >
          <span className="text-[19px] font-semibold">Purpose Code</span>
          <div
            onClick={() => {
              setIsPurposeModalOpen(true);
              // if (
              //   purposeValue === "Family Maintenance" ||
              //   purposeValue === "Personal Gift or Donation"
              // ) {
              //   setFirstTimeLoanPopup(true);
              //   setIsModalOpen("loan");
              // } else {
              //   setFirstTimeLoanPopup(false);
              // }
            }}
            className="flex py-[17px]  w-[520px] font-semibold bg-blue-100
             items-center justify-between border rounded-md cursor-pointer"
          >
            <span className="px-5 font-normal">
              {purposeValue ? purposeValue : "Select Purpose"}
            </span>
            <div className="mr-5 purposeCode-dropdown-icon">
              <DropdownIcon />
            </div>
          </div>
          {purposeValue?.toLowerCase()?.includes("family") || purposeValue?.toLowerCase()?.includes("donation") ?
            <span className="text-red-200 ml-[10px]">
              User may receive the lesser amount due to the beneficiary bank charges.
            </span> : null}
        </div>
        <div id="Enter Rate" className="flex flex-col">
          <span className="text-[19px] font-semibold">Enter Rate</span>
          <div className="flex flex-col mr-5 my-3">
            <div className="flex items-center space-x-3">
              <DebounceInput
                minLength={2}
                className={`w-full rounded-md p-[3.4%] bg-blue-100 text-lg outline-none ${editable === true || !purposeCode ? "opacity-15":""}`}
                name="recievingAmount"
                type="number"
                value={rate}
                debounceTimeout={1000}
                onChange={validateRate}
                fullWidth
                inputClasses="text-[20px] bg-blue-100"
                disabled={editable === true || !purposeCode}
              />
              <div onClick={() => setEditable(!editable)}>
                {editable === true ? <NotEditable width="20px" /> : <Editable />}
              </div>
              <div className="w-[120px] flex space-x-3">
                <span className="font-semibold text-[18px]">{destCurrency}</span>
                <TransferIcon />
                <span className="font-semibold text-[18px]">INR</span>
              </div>
            </div>
            {purposeValue && (
              <span className="font-semibold pt-0.5">
                Card rate for {`${destCurrency} - ${cardRateToShow}`}
              </span>
            )}
            { !purposeCode &&         
              <span className="font-semibold text-red-500 text-[13px] animate-fade">
              Please select the Purpose Code  to edit the exchange rate
            </span>}
          </div>
        </div>
        <div id="Vendor Code" className="flex flex-col">
          <span className="text-[19px] font-semibold">Vendor Name/Code</span>
          <VendorDropdown onVendorChange={handleDataFromChild} />
        </div>
      </div>
      <div id="submit" className="flex gap-5 justify-center mb-0">
        <div id="download quote" className={`flex items-center justify-center bg-white  py-4 mt-6 ml-5 px-6 hover:scale-105 transition-all text-blue font-roboto text-base font-bold rounded border border-blue-500 ${!purposeCode ? "cursor-not-allowed opacity-15": "cursor-pointer opacity-100"}`} onClick={handleDownloadQuoteClick}>
        {/* <button className="pl-2" onClick={handleDownloadQuoteClick}>
          <DownloadIcon />
          <div className="justify-center ">
            <ToastContainer containerId={"downloadQuote"} position="bottom-center" hideProgressBar />
          </div>
        </button> */}
        <span className="font-medium text-[18px]"> Download quote</span>
            <div className="justify-center ">
            <ToastContainer containerId={"downloadQuote"} position="bottom-center" hideProgressBar />
          </div>
      </div>
        <Button
          bgColor={
            isErrorPresent ||
              getSendMoneyErrorMessage(destCurrency, sendingAmount) !== "" ||
              purposeCode === "" ||
              purposeValue === "" ||
              !vendorCode ||
              (typeof vendorCode === "object" && Object.keys(vendorCode).length === 0) ||
              vendorCode.displayName === "" ||
              loading
              ? "bg-gray-300"
              : "bg-primary-1050"
          }
          fontStyle={{
            fontFamily: "font-roboto",
            fontSize: "text-base",
            fontWeight: "font-bold",
            fontColor: "text-white",
          }}
          borderStyle={{
            borderRadius: "rounded",
          }}
          onClickHandler={proceedClick}
          className={"flex justify-center py-4 mt-6 ml-5 px-14 hover:scale-105 transition-all"}
          disabled={
            isErrorPresent ||
            getSendMoneyErrorMessage(destCurrency, sendingAmount) !== "" ||
            purposeCode === "" ||
            purposeValue === "" ||
            !vendorCode ||
            (typeof vendorCode === "object" && Object.keys(vendorCode).length === 0) ||
            vendorCode.displayName === "" ||
            loading
          }
        >
          Proceed
        </Button>
 
        {/* <Dialog open={firstTimeLoanPopup === false && tcs>0 && openModal} onClose={() => setIsModalOpen("")}>
          <div className="flex flex-col items-center p-10">
            <span className="font-semibold text-[24px] mt-6">
              If a loan has been taken for overseas education and the loan disbursement letter is
            </span>
            <span className="font-semibold text-[24px] mt-0">
              available, TCS will be charged at 0.5%. Is a loan disbursement letter available?
            </span>
            <span className="font-semibold text-[20px] mt-6">
              Note: You will be asked to upload a digital copy of the loan disbursement letter.
            </span>
            <div className="flex space-x-10">
              <button
                className="px-6 py-3 mt-5 border border-black rounded-lg"
                onClick={() => {
                  setOpenModal(false);
                  setFirstTimeLoanPopup(true);
                }}
              >
                Yes
              </button>
              <button
                className="px-6 py-3 mt-5 border border-black rounded-lg"
                onClick={() => {
                  setOpenModal(false);
                  setFirstTimeLoanPopup(true);
                }}
              >
                No
              </button>
            </div>
          </div>
        </Dialog> */}
      </div>

    </div>
  );
};
